// import { canUseDOM } from 'exenv';

export function personIndexSectionLoading(resp = {}, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_LOADING',
    personIndexSection: resp,
    store
  };
}

export function personIndexSectionLoaded(resp = {}, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_LOADED',
    personIndexSection: resp,
    store
  };
}

export function personIndexSectionLoadError(error, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_ERROR',
    personIndexSection: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
